import styled from 'styled-components'
import { motion } from 'framer-motion'

// eslint-disable-next-line import/prefer-default-export
export const CompanyWrapper = styled(motion.div)`
  max-width: 380px;
  margin: auto;
  padding: 40px 10px;
  display: flex;
  justify-ontent: center;
  flex-direction: column;
  align-items: center;

  .company-title {
    font-family: 'Exo 2', sans-serif !important;
    font-size: 26px;
    margin-top: 30px;
    font-weight: 500;
  }

  .company-desc {
    text-align: center;
    font-family: 'Exo 2', sans-serif !important;
    font-weight: 300;
    font-size: 14px;
    margin: 10px auto 0px;
  }

  .ant-result-title {
    color: #000000d9;
    font-size: 19px;
    line-height: 1.8;
    text-align: center;
    font-weight: 700;
  }

  .loader-wrapper {
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50vh;
    }
  }
`
